import React from 'react';
import Link from '../../Link';
import '../index.css';

export function DeepGutPricing() {
  const domain = typeof window !== `undefined` ? window.location.hostname : ``;

  return (
    <div className="w-full md:p-[24px] p-8 md:mt[40px] slg:mt-0 md:pt-[48px]">
      <div className="flex flex-col gap-y-[23px]">
        <div className="bg-[#F4F8F5] rounded-lg">
          <img src="/images/deep-gut-test.svg" alt="" className="w-full" />
        </div>
        <div>
          <div className="flex flex-col">
            <h3 className="text-xl font-medium text-navy-blue">DeepGut</h3>
            <span className="italic text-[#A3A1A8] font-medium mt-3">
              Practitioners only
            </span>
          </div>
          <div className="flex flex-col gap-y-5">
            <div className="flex flex-col">
              <p className="text-base font-medium text-navy-blue mt-5">
                Advanced Metagenomic microbiome test
              </p>
              <span className="text-base font-medium">
                (Whole genome sequencing)
              </span>
            </div>
            <div className="text-sm">
              *Create a practitioner account, login and order DeepGut through
              your practitioner portal
            </div>
          </div>
        </div>
        {domain.includes(`.ca`) ||
        domain.includes(`vitract-ca.netlify.app/pricing/`) ? (
          <Link
            href="https://app.vitract.com/practitioner-registration"
            target="_blank"
          >
            <button
              type="button"
              className="mt-auto slg:mt-[41px] xl:mt-[17.5px] w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        ) : (
          <Link
            href="https://app.vitract.com/practitioner-registration"
            target="_blank"
          >
            <button
              type="button"
              className="mt-auto slg:mt-[41px] xl:mt-[17.5px] w-full border border-navy-blue border-solid rounded text-navy-blue hover:bg-navy-blue hover:text-white py-3 text-base font-medium"
            >
              Order Now
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}
